import { View } from 'react-native';

import { cn } from '@/components/ui/cn';
import { Text } from '@/components/ui/Text';

export interface SealedLogHeaderProps {
  title: string;
  /** Snapshotted template description, frozen at spin-up. */
  description?: string | null;
  className?: string;
}

/** The frozen/immutable header for a completed run. The "Sealed run" marker
 *  lives in the nav bar and the who/when in the summary card below. */
export function SealedLogHeader({ title, description, className }: SealedLogHeaderProps) {
  return (
    <View className={cn('gap-2', className)}>
      <Text variant="title">{title}</Text>
      {description ? (
        <Text variant="body" className="text-foreground-secondary">
          {description}
        </Text>
      ) : null}
    </View>
  );
}
